import React from 'react';
import { useRouter } from 'next/router';
import { Card, Col, Grid, Row, Typography } from 'antd';
import classNames from 'classnames';

import ImageC from 'src/components/Image';
import g from 'src/constants/global';

import classes from './index.module.less';

const terapyType = [
	{
		title: 'Terapi Stem Cell di Indonesia',
		description:
			// eslint-disable-next-line max-len
			'Pengobatan menggunakan stem cell menjadi suatu terobosan yang berpotensi menyembuhkan berbagai penyakit berat, kronis, degeneratif, dan autoimun.',
		image: '/images/stem-cell/cell-dna.png',
		url: g.STEM_CELL.URLS.REGISTER,
		external_link: true,
	},
	{
		title: 'Terapi Secretome di Indonesia',
		description:
			// eslint-disable-next-line max-len
			'Terapi kesehatan secretome kini menjadi populer karena dianggap mampu meringankan berbagai kondisi klinis seperti peradangan, peremajaan kulit hingga masalah kebotakan.',
		image: '/images/stem-cell/cell-embrio.png',
		url: '/info-stem-cell/secretome',
		external_link: false,
	},
];

const TerapiType = () => {
	const r = useRouter();
	const { xs, xl } = Grid.useBreakpoint();

	return (
		<div className="bg-white">
			<div className={classNames('container py-3', classes['tipe-terapi'])}>
				<div className="py-3 text-center">
					<Typography.Title level={2} className={classes.title}>
						Jenis Terapi
					</Typography.Title>
				</div>
				<Row gutter={{ md: 60, xs: 0 }}>
					{terapyType.map((item, idx) => (
						<Col
							key={idx}
							md={12}
							xs={24}
							style={{ borderRadius: '17px', marginTop: idx === 1 && xs ? '20px' : 0 }}
						>
							<div className="text-center">
								<ImageC
									width={xl ? 160 : 95}
									height={xl ? 160 : 95}
									src={item.image}
									style={{ borderRadius: '17px', zIndex: '10' }}
								/>
							</div>
							<Card className={classes.cardType}>
								<div>
									<div className={classes.cardDescription}>
										<Typography.Title level={3} className={classes.subtitle}>
											{item.title}
										</Typography.Title>
										<Typography.Paragraph className={classes.description}>
											{item.description}
										</Typography.Paragraph>
									</div>
									<div className="py-4 text-center">
										<a href={item.url} rel="noopener noreferrer">
											<Typography.Text className={classes.link} onClick={() => r.push(item.url!)}>
												Pelajari di Sini!
											</Typography.Text>
										</a>
									</div>
								</div>
							</Card>
						</Col>
					))}
				</Row>
			</div>
		</div>
	);
};

export default TerapiType;
